export default __webpack_public_path__ + "static/media/favicon.3310f952.svg";